import { Grid, styled } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/icons/logo_transparent.svg";

const AnimationLoad = styled("div")(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  height: "100%",
  left: "0",
  position: "fixed",
  top: "0",
  width: "100%",
  zIndex: "10000",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const LoadingContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
}));

const StyledLogo = styled(Logo)(({ theme }) => ({
  "@keyframes pulse": {
    "0%": {
      opacity: 0.6,
      transform: "scale(0.98)",
    },
    "50%": {
      opacity: 1,
      transform: "scale(1)",
    },
    "100%": {
      opacity: 0.6,
      transform: "scale(0.98)",
    },
  },
  width: "100px",
  height: "100px",
  animation: "pulse 1.5s ease-in-out infinite",
  "& path": {
    fill: "white",
    opacity: "1",
  },
}));

const LoadingText = styled("div")(({ theme }) => ({
  color: "white",
  fontSize: "1.2rem",
  fontWeight: "500",
  letterSpacing: "2px",
  "@keyframes dots": {
    "0%": { content: '"."' },
    "33%": { content: '".."' },
    "66%": { content: '"..."' },
    "100%": { content: '"."' },
  },
  "&::after": {
    content: '"."',
    animation: "dots 1.5s steps(4, end) infinite",
  },
}));

const Loading = ({ text = "Loading" }) => {
  return (
    <Grid container>
      <AnimationLoad>
        <LoadingContainer>
          <StyledLogo />
          <LoadingText>{text}</LoadingText>
        </LoadingContainer>
      </AnimationLoad>
    </Grid>
  );
};

export default Loading;
